import { stringifyUrl } from "query-string";
import { useEffect, useState } from "react";

// 获取以太坊签名解码 https://www.4byte.directory/docs/
export const use4byteSignQuery = ({
  chain,
  inputs,
  onSuccess,
}: {
  chain: number;
  inputs?: string;
  onSuccess?: (results: any) => void;
}) => {
  const [data, setData] = useState<{
    [key: string]: { count: number; results: any[] };
  }>({});
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState<{ inputs: string }>({ inputs: "" });

  const run = (nextParams: { inputs: string }) => {
    setParams({ ...params, ...nextParams });
  };

  useEffect(() => {
    if (inputs) {
      setParams({ ...params, inputs });
    }
    //eslint-disable-next-line
  }, [inputs]);

  useEffect(() => {
    if (params?.inputs?.length <= 0 || !chain) return;
    setIsLoading(true);

    let fetchPromises: any = [];
    let inputArr = params?.inputs
      ?.split(",")
      .filter((input) => !["0x"].includes(input));
    inputArr = [...(new Set(inputArr) as any)]; // 去重

    inputArr?.forEach((input) => {
      const path = "https://www.4byte.directory/api/v1/signatures/";
      const endpoint = stringifyUrl({
        url: path,
        query: { hex_signature: input, ordering: "created_at" },
      });

      fetchPromises.push(
        fetch(endpoint).catch((error) => {
          console.log("error hex_signature", input);
          // 请求失败了，伪造成功的结果，避免报错
          return Promise.resolve({
            json: () => Promise.resolve({ results: [] }),
          });
        })
      );
    });

    Promise.all(fetchPromises)
      .then(async (result) => {
        let data = {};
        let idx = 0;

        for (const resultPromise of result) {
          const input = inputArr[idx++];
          const json = await resultPromise.json();
          data = { ...data, [input]: json };
        }

        setData(data);

        onSuccess?.({ results: data, params });
      })
      .finally(() => {
        setIsLoading(false);
      });
    //eslint-disable-next-line
  }, [chain, params?.inputs]);

  return {
    data,
    isLoading,
    run,
  };
};
